// Validated, typed environment. Fails fast at startup if a required public var is
// missing/malformed, rather than surfacing a confusing runtime error later.
import { z } from "zod";

const EnvSchema = z.object({
  VITE_SUPABASE_URL: z.string().url(),
  VITE_SUPABASE_ANON_KEY: z.string().min(1),
  VITE_TURNSTILE_SITE_KEY: z.string().min(1),
  VITE_SUBMIT_LEAD_URL: z.string().url().optional(),
});

const parsed = EnvSchema.safeParse(import.meta.env);
if (!parsed.success) {
  // Names only — never the values (which would leak keys to the console).
  const missing = parsed.error.issues.map((i) => i.path.join(".")).join(", ");
  throw new Error(`Invalid or missing environment variables: ${missing}`);
}

const raw = parsed.data;

export const env = {
  supabaseUrl: raw.VITE_SUPABASE_URL,
  supabaseAnonKey: raw.VITE_SUPABASE_ANON_KEY,
  turnstileSiteKey: raw.VITE_TURNSTILE_SITE_KEY,
  submitLeadUrl: raw.VITE_SUBMIT_LEAD_URL ?? `${raw.VITE_SUPABASE_URL}/functions/v1/submit-lead`,
  isDev: import.meta.env.DEV,
} as const;
